/**
 * Tracking Configuration
 *
 * Third-party tracking IDs and conversion tags.
 *
 * Environment-specific IDs come from .env.local — leave them unset on dev
 * machines so no analytics fire into the production properties. Every tag
 * component and event helper no-ops when its ID is absent.
 */

// Google Analytics 4
export const GA4_ID = process.env.NEXT_PUBLIC_GA4_ID

// Google Ads (remarketing tag + conversion destination)
export const GAAW_ID = process.env.NEXT_PUBLIC_GAAW_ID

// Google Ads purchase conversion label, appended to the tag id per gtag convention
const GOOGLE_ADS_CONVERSION_LABEL = process.env.NEXT_PUBLIC_GOOGLE_ADS_CONVERSION_LABEL
export const GOOGLE_ADS_CONVERSION_ID = (GAAW_ID && GOOGLE_ADS_CONVERSION_LABEL)
    ? `${GAAW_ID}/${GOOGLE_ADS_CONVERSION_LABEL}`
    : undefined

// Google Search Console verification
export const GOOGLE_SITE_VERIFICATION = process.env.NEXT_PUBLIC_GOOGLE_SITE_VERIFICATION

// Microsoft/Bing UET
export const BING_UET_ID = process.env.NEXT_PUBLIC_BING_UET_ID

// Reseller Ratings post-purchase survey
export const RESELLER_RATINGS_SELLER_ID = process.env.NEXT_PUBLIC_RESELLER_RATINGS_SELLER_ID
export const RESELLER_RATINGS_SCRIPT_URL = 'https://www.resellerratings.com/popup/include/Hive_Modern.js'
